import React, {
  useState,
  Fragment,
  useRef,
  useContext,
  useEffect,
} from "react";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PhoneIcon from "@mui/icons-material/Phone";
import RoomIcon from "@mui/icons-material/Room";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import GridViewIcon from "@mui/icons-material/GridView";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import useStyles from "../../../../SharedClass/sharedClass";
import { BsArrowRight } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import "./AddBusiness.css";
import {
  Button,
  Box,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";
import theme from "../../../../utils/theme";
import { FaSave } from "react-icons/fa";
import * as Yup from "yup";
import { useFormik } from "formik";
import useCommonQuery from "../../../../store/common/useCommonQuery";
import { uploadFileToS3 } from "../../../../utils/s3Upload";
import S3 from "react-aws-s3";
import { Buffer } from "buffer";
import useBusinessQuery from "../../../../store/Bussiness/useBusinessQuery";
import { variableContext } from "../../../../context/VariableContex";
import deleteicon from "../../../../assets/deleteicon.png";
import ImageRemovalModal from "./ImageRemovalModal";
import ErrorModal from "./ErrorModal";
import SuccessModal from "./SuccessModal";
import CropModal from "./CropModal";
import axios from "axios";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import HomeIcon from "@mui/icons-material/Home";
import AccountCircleIcon from "@mui/icons-material/AccountCircleOutlined";
import CardMembershipIcon from "@mui/icons-material/CardMembershipOutlined";
import UploadModal from "../../../../components/UploadModal";
import CategoryModal from "../../../../components/CategoryModal/Index";
import SubCategoryModal from "../../../../components/SubCategoryModal/Index";
import useAuthQuery from "../../../../store/auth/useAuthQuery";
import VerifyErrorModal from "./VerifyErrorModal";
window.Buffer = Buffer;

const AddBusiness = () => {
  const {
    latitude: lat,
    longitude: long,
    setLatitude: setLat,
    setLongitude: setLong,
    mobile,
  } = useContext(variableContext);

  const history = useHistory();
  const classes = useStyles();
  const ref = useRef();
  const photoref = useRef();
  const catelogueRef = useRef();
  const premiumRef = useRef();

  const Api_Key = "AIzaSyDMC5uUfcSScgVY9AGqsGQwYm8P6_LmyYg";

  const [show, setShow] = useState("business");
  const [add, setAdd] = useState([
    { name: "" },
    { name: "" },
    { name: "" },
    { name: "" },
    { name: "" },
  ]);
  const [state, setState] = useState(1);
  const [district, setDistrict] = useState("");
  const [postOffice, setPostOffice] = useState("");
  const [pincode, setPincode] = useState("");
  const [about, setAbout] = useState("");
  const [name, setName] = useState("");
  const [type, setType] = useState("shop");
  const [category, setCategory] = useState("");
  const [googleLocation, setGoogleLocation] = useState("");
  const [Whatsapp, setWhatsApp] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [google_review_link, setGoogle_review_link] = useState("");
  const [youtube, setYoutube] = useState("");
  const [website, setWebsite] = useState("");
  const [cover, setCover] = useState([]);
  const [photos, setPhotos] = useState("");
  const [catelogue, setCatelogue] = useState([]);
  const [premium, setPremium] = useState([]);
  const [poster, setPoster] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [phonenumber, setPhonenumber] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [croppingImage, setCroppingImage] = useState();
  const [openCropModal, setOpenCropModal] = useState(false);
  const [placeName, setPlaceName] = useState("");
  const [locationError, setLocationError] = useState("");
  const [uploadModal, setUploadModal] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [categoryModal, setCategoryModal] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryModal, setSubCategoryModal] = useState(false);
  const [subCategoryId, setSubCategoryId] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSuccessModal, setOtpSuccessModal] = useState(false);
  const [nameError, setNameError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [location_info, setLocationInfo] = useState("");
  const [newCatelogue, setNewCatelogue] = useState();
  const [categoryImage, setCategoryImage] = useState("");
  const [subCategoryImage, setSubCategoryImage] = useState("");

  // ── Dirty state: true only when user has actually changed a field ──
  const isDirty = useRef(false);
  const markDirty = () => { isDirty.current = true; };

  const envConfig = process.env;

  const config = {
    bucketName: envConfig.REACT_APP_S3_BUCKET,
    region: envConfig.REACT_APP_S3_REGION,
    dirName: "master-click",
    accessKeyId: envConfig.REACT_APP_S3_ACCESS_KEY_ID,
    secretAccessKey: envConfig.REACT_APP_S3_SECRET_ACCESS_KEY,
  };
  const ReactS3Client = new S3(config);

  const { data: districtList } = useCommonQuery.Get_district(state);

  // ── Category + subcategory icon lookup (same source as Admin Panel / Profile.jsx) ──
  const { data: allCategories } = useCommonQuery.Get_category({ search: "", limit: 2000, offset: 0 });
  const { data: allSubCategories } = useCommonQuery.Get_subcategory({
    id: categoryId || undefined,
    search: "",
    limit: 2000,
    offset: 0,
  });

  const { data: trailPlan } = useBusinessQuery.Get_trial_plan();

  // ── Detect existing business record for the logged-in customer ──
  const { data: myBizList, isSuccess: myBizSuccess } =
    useBusinessQuery.Get_my_bussiness();

  // existingBizId is set once the list resolves; null means new customer
  const [existingBizId, setExistingBizId] = useState(null);
  const seeded = useRef(false);

  const { data: bizDetail, isSuccess: bizDetailSuccess } =
    useBusinessQuery.Get_my_bussiness_details(existingBizId);

  const {
    mutateAsync: AddBusiness,
    isSuccess,
    isLoading: isAddingBusiness,
    isError,
    error: businessError,
  } = useBusinessQuery.Add_business();

  const {
    mutateAsync: EditBusiness,
    isSuccess: editSuccess,
    isLoading: isEditingBusiness,
    isError: editIsError,
    error: editError,
  } = useBusinessQuery.Edit_business();

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, onError);
    }
  }

  function onError(error) {
    if (error) {
      // setOpenLocation(true);
    }
  }

  function showPosition(position) {
    setLat(position.coords.latitude);
    setLong(position.coords.longitude);
  }

  const fetchCityName = async () => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${Api_Key}`
      );
      const results = response.data.results;
      if (results && results.length > 0) {
        const addressComponents = results[0].address_components;
        for (const component of addressComponents) {
          if (component.types.includes("locality")) {
            setPlaceName(component.long_name);
            setLocationInfo(component.long_name);
            break;
          }
        }
      }
    } catch (error) { }
  };

  // Reverse-geocode from stored lat/lng (used when seeding existing record)
  const fetchCityNameFromCoords = async (latVal, lngVal) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latVal},${lngVal}&key=${Api_Key}`
      );
      const results = response.data.results;
      if (results && results.length > 0) {
        const addressComponents = results[0].address_components;
        for (const component of addressComponents) {
          if (component.types.includes("locality")) {
            setPlaceName(component.long_name);
            break;
          }
        }
      }
    } catch (error) { }
  };

  // ── Step 1: resolve existing business ID ──
  useEffect(() => {
    if (myBizSuccess && myBizList?.data?.results?.length > 0) {
      setExistingBizId(myBizList.data.results[0].id);
    }
  }, [myBizSuccess, myBizList]);

  // ── Resolve category image from common API when categoryId changes ──
  useEffect(() => {
    if (!categoryId || !allCategories?.data?.results) return;
    const match = allCategories.data.results.find(
      (c) => String(c.id) === String(categoryId)
    );
    if (match?.image) setCategoryImage(match.image);
  }, [categoryId, allCategories]);

  // ── Resolve subcategory image from common API when subCategoryId changes ──
  useEffect(() => {
    if (!subCategoryId || !allSubCategories?.data?.results) return;
    const match = allSubCategories.data.results.find(
      (s) => String(s.id) === String(subCategoryId)
    );
    if (match?.image) setSubCategoryImage(match.image);
  }, [subCategoryId, allSubCategories]);

  // ── Step 2: seed form from existing record (runs once) ──
  useEffect(() => {
    if (!bizDetailSuccess || !bizDetail?.data || seeded.current) return;
    const d = bizDetail.data;
    seeded.current = true;
    if (d.name)           setName(d.name);
    if (d.mobile_number)  setPhonenumber(d.mobile_number);
    if (d.type)           setType(d.type);
    if (d.district)       setDistrict(d.district);
    if (d.post_office)    setPostOffice(d.post_office);
    if (d.pin_code)       setPincode(d.pin_code);
    if (d.about_us)       setAbout(d.about_us);
    if (d.category)       setCategoryId(d.category);
    if (d.category_name)  setCategory(d.category_name);
    if (d.sub_category)   setSubCategoryId(d.sub_category);
    if (d.sub_category_name) setSubCategory(d.sub_category_name);
    if (d.latitude)       setLatitude(d.latitude);
    if (d.longitude)      setLongitude(d.longitude);
    if (d.image)          setPhotos(d.image);
    if (d.banner_image)   setPoster(d.banner_image);
    if (d.whatsapp_number)    setWhatsApp(d.whatsapp_number);
    if (d.facebook)           setFacebook(d.facebook);
    if (d.instagram)          setInstagram(d.instagram);
    if (d.google_review_link) setGoogle_review_link(d.google_review_link);
    if (d.youtube)            setYoutube(d.youtube);
    if (d.website)            setWebsite(d.website);
    if (d.google_location_link) setGoogleLocation(d.google_location_link);
    if (d.location_info)  setLocationInfo(d.location_info);
    if (d.state)          setState(d.state);
    // seed cover images
    if (Array.isArray(d.cover_images) && d.cover_images.length > 0) {
      setCover(d.cover_images.map((ci) => ci.cover_image || ci));
    }
    // seed catalogue images
    if (Array.isArray(d.catalogue_images) && d.catalogue_images.length > 0) {
      setCatelogue(
        d.catalogue_images.map((ci) => ({
          url: ci.catalogue_image || ci.url || "",
          title: ci.name || ci.title || "",
          titleError: "",
        }))
      );
    }
    // seed services
    if (Array.isArray(d.services) && d.services.length > 0) {
      const svcRows = d.services.map((s) => ({ name: s.name || "" }));
      // pad to at least 5 rows
      while (svcRows.length < 5) svcRows.push({ name: "" });
      setAdd(svcRows);
    }
    // resolve place name from existing coordinates
    if (d.latitude && d.longitude) {
      fetchCityNameFromCoords(d.latitude, d.longitude);
    }
  }, [bizDetailSuccess, bizDetail]);

  useEffect(() => {
    if (mobile) {
      setPhonenumber(mobile);
      setWhatsApp(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (lat && long) {
      fetchCityName();
      setLatitude(lat);
      setLongitude(long);
    }
  }, [lat, long]);

  const handleLocation = (place) => {
    let lat = place.geometry.location.lat();
    let long = place.geometry.location.lng();
    setLatitude(lat);
    setLongitude(long);
    setLocationInfo(place.name);
    setLocationError("");
  };

  const handleSave = async () => {
    let error = false;
    if (name.trim() == "") {
      setNameError("Business name is required");
      error = true;
    }
    if (!phonenumber.trim()) {
      setPhoneNumberError("Phone number is required");
      error = true;
    }
    // Allow saving without location if an existing record already has coordinates
    const hasLocation = latitude !== "" && longitude !== "";
    const existingHasLocation =
      bizDetail?.data?.latitude && bizDetail?.data?.longitude;
    if (!hasLocation && !existingHasLocation) {
      setLocationError("Location is required");
      error = true;
    }
    if (categoryId == "") {
      error = true;
      setCategoryError("Category is required");
    }

    if (error) return;

    const payload = {
      name,
      type: type || "shop",
      mobile_number: phonenumber,
      category: categoryId,
      latitude: latitude || bizDetail?.data?.latitude,
      longitude: longitude || bizDetail?.data?.longitude,
      image: photos,
      banner_image: poster,
    };
    if (subCategoryId) payload.sub_category = subCategoryId;

    try {
      if (existingBizId) {
        // UPDATE existing record
        await EditBusiness({ ...payload, id: existingBizId });
      } else {
        // CREATE new record
        await AddBusiness(payload);
      }
    } catch (error) { }
  };

  const handleImage = () => {
    setOpenCropModal(true);
    setCroppingImage("");
  };

  const handleCloseCrop = () => {
    if (show == "photos") {
      setPhotos(croppingImage);
    } else if (show == "coverPhoto") {
      setCover([...cover, croppingImage]);
    } else if (show == "catelogue") {
      setCatelogue([...catelogue, croppingImage]);
    } else if (show == "poster") {
      setPoster(croppingImage);
    }

    setOpenCropModal(false);
  };

  const handleClose = (value) => {
    if (value) {
      if (selectedImage == "cover") {
        const data = cover.filter((item, i) => i != id);
        setCover([...data]);
      } else if (selectedImage == "premium") {
        const data = premium.filter((item, i) => i != id);
        setPremium([...data]);
      } else if (selectedImage == "photos") {
        setPhotos("");
      } else if (selectedImage == "catelogue") {
        const data = catelogue.filter((item, i) => i != id);
        setCatelogue([...data]);
      } else {
        setPoster("");
      }
      markDirty();
    }
    setOpenModal(false);
  };

  const handleError = () => {
    setAbout("");
    setAdd([
      { name: "" },
      { name: "" },
      { name: "" },
      { name: "" },
      { name: "" },
    ]);
    setCategory("");
    setCatelogue([]);
    setCover([]);
    setDistrict("");
    setFacebook("");
    setGoogleLocation("");
    setPhonenumber("");
    setInstagram("");
    setGoogle_review_link("");
    setName("");
    setPincode("");
    setPhotos("");
    setPostOffice("");
    setType("shop");
    setShow("business");
    setOpenError(false);

    setPoster("");
    setPremium([]);
  };

  const handleSuccess = () => {
    setOpenSuccess(false);
    // Navigate to profile after a successful save
    history.push("/my-profile");
  };

  const handleCloseUpload = () => {
    setUploadModal(false);
    setIsUploading(false);
  };

  const handleCategoryModal = (data) => {
    if (data.name) setCategoryError("");
    setCategoryModal(false);
    setCategoryId(data.id);
    setCategory(data.name);
    setCategoryImage(data.image || "");
    // reset subcategory when category changes
    setSubCategoryId("");
    setSubCategory("");
    setSubCategoryImage("");
    markDirty();
  };

  const handleSubCategoryModal = (data) => {
    setSubCategoryModal(false);
    setSubCategoryId(data.id);
    setSubCategory(data.name);
    setSubCategoryImage(data.image || "");
    markDirty();
  };

  const validateForm = () => {
    let error = null;
    const data = catelogue.map((item) => {
      if (item.title == "") {
        item.titleError = "Required";
        error = true;
      }
      return item;
    });
    setCatelogue([...data]);
    return error;
  };

  const handleBusiness = async () => {
    if (!validateForm()) {
      let payload = {
        name,
        type: type || "shop",
        mobile_number: phonenumber,
        category: categoryId,
        sub_category: subCategoryId,
        district,
        post_office: postOffice,
        pin_code: pincode,
        latitude: latitude || bizDetail?.data?.latitude,
        longitude: longitude || bizDetail?.data?.longitude,
        about_us: about,
        image: photos,
        banner_image: poster,
        location_info,
        catalogue_image: catelogue?.map((item) => ({
          catalogue_image: item?.url,
          is_active: true,
          name: item?.title,
        })),
        cover_image: cover.map((item) => ({
          cover_image: item ? item : "",
          is_active: true,
        })),
        social_medias: {
          google_location_link: googleLocation,
          whatsapp_number: Whatsapp,
          facebook,
          instagram,
          google_review_link,
          youtube,
          website,
        },
        service: add
          .filter((item) => Boolean(item.name))
          ?.map((data) => ({ ...data, is_active: true })),
      };
      if (!payload.pin_code)    delete payload.pin_code;
      if (!payload.sub_category) delete payload.sub_category;
      try {
        if (existingBizId) {
          // UPDATE existing record
          await EditBusiness({ ...payload, id: existingBizId });
        } else {
          // CREATE new record
          await AddBusiness(payload);
        }
      } catch (error) { }
    }
  };

  const handleAdd = (e, i) => {
    let data = add[i];
    data.name = e.target.value;
    add[i] = data;
    setAdd([...add]);
    markDirty();
  };

  useEffect(() => {
    if (isSuccess || editSuccess) {
      isDirty.current = false; // reset after successful save
      setOpenSuccess(true);
    }
    if (isError && businessError) {
      setErrorMessage(businessError?.data?.message);
      setOpenError(true);
    }
    if (editIsError && editError) {
      setErrorMessage(editError?.data?.message || "Update failed");
      setOpenError(true);
    }
  }, [isSuccess, isError, businessError, editSuccess, editIsError, editError]);


  const handleCoverImage = async (e) => {
    console.log('hiiiii')
    try {
      let file = null;

      // If we have an event with files (from a standard input)
      if (e && e.target && e.target.files) {
        if (e.target.files.length === 0) {
          return;
        }
        file = e.target.files[0];
      }
      // Otherwise use either Flutter channel or create a file input
      else {
        // Flutter file channel approach
        if (window.FileChannel) {
          // Set up a callback to receive file data
          file = await new Promise((resolve, reject) => {
            // This part still needs a Promise since we're setting up a callback
            window.fileCallback = (fileData) => {
              console.log('Raw fileData received:', fileData);

              // Handle different possible data formats
              try {
                // Case 1: If fileData is an object with structured properties
                if (typeof fileData === 'object' && fileData !== null) {
                  const { fileName, fileBase64, fileSize, fileType } = fileData;
                  console.log('Structured data detected:', { fileName, fileSize, fileType });

                  if (fileBase64) {
                    // Process base64 data
                    let base64Content = fileBase64;
                    if (fileBase64.includes('base64,')) {
                      base64Content = fileBase64.split('base64,')[1];
                    }

                    // Create blob and file
                    const byteCharacters = atob(base64Content);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: fileType || 'image/jpeg' });
                    const fileObject = new File([blob], fileName || `image_${Date.now()}.jpg`, { type: fileType || 'image/jpeg' });

                    console.log('Created File object from structured data');
                    return resolve(fileObject);
                  }
                }

                // Case 2: If fileData is a string containing base64 data
                if (typeof fileData === 'string') {
                  console.log('String data detected, length:', fileData.length);

                  // If it's base64 format
                  if (fileData.includes('base64')) {
                    const matches = fileData.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

                    if (matches && matches.length === 3) {
                      const mimeType = matches[1];
                      const base64Data = matches[2];

                      // Process base64 data
                      const byteCharacters = atob(base64Data);
                      const byteArrays = [];

                      for (let i = 0; i < byteCharacters.length; i += 1024) {
                        const slice = byteCharacters.slice(i, i + 1024);
                        const byteNumbers = new Uint8Array(slice.length);

                        for (let j = 0; j < slice.length; j++) {
                          byteNumbers[j] = slice.charCodeAt(j);
                        }

                        byteArrays.push(byteNumbers);
                      }

                      const blob = new Blob(byteArrays, { type: mimeType });
                      const fileObject = new File([blob], `image_${Date.now()}.${mimeType.split('/')[1] || 'jpg'}`, { type: mimeType });

                      console.log('Created File object from base64 string');
                      return resolve(fileObject);
                    }
                  }

                  // If it's comma-separated format
                  const parts = fileData.split(',');
                  if (parts.length >= 3) {
                    const [path, name, size] = parts;
                    console.log('Comma-separated data detected:', { path, name, size });
                    // Here we don't have actual file content, just returning the raw data
                    return resolve(fileData);
                  }

                  // If it's just raw base64 without prefix
                  try {
                    // Assume it might be raw base64
                    const byteCharacters = atob(fileData);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
                    const fileObject = new File([blob], `image_${Date.now()}.jpg`, { type: 'image/jpeg' });

                    console.log('Created File object from raw base64');
                    return resolve(fileObject);
                  } catch (e) {
                    console.log('Not valid base64 data');
                  }
                }

                // Fall back to just returning whatever we got
                console.log('Using raw data as fallback');
                return resolve(fileData);
              } catch (error) {
                console.error('Error processing file data:', error);
                return reject(error);
              }
            };

            console.log('Requesting file from Flutter...');
            try {
              window.FileChannel.postMessage('chooseFile');
            } catch (err) {
              console.error('Error calling FileChannel:', err);
              reject(err);
            }
          });
        }
        // Fallback to standard file input approach
        else {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.style.display = 'none';
          document.body.appendChild(input);

          // We need to wrap this in a Promise because file selection is event-based
          file = await new Promise((resolve, reject) => {
            input.onchange = (event) => {
              document.body.removeChild(input);
              if (event.target.files && event.target.files.length > 0) {
                const selectedFile = event.target.files[0];
                console.log('Selected file:', selectedFile);
                resolve(selectedFile);
              } else {
                reject(new Error('No file selected'));
              }
            };

            // Add focus listener to clean up if user cancels
            window.addEventListener('focus', function cleanup() {
              setTimeout(() => {
                if (document.body.contains(input)) {
                  document.body.removeChild(input);
                }
              }, 1000);
              window.removeEventListener('focus', cleanup);
            }, { once: true });

            input.click();
          });
        }
      }

      if (file) {
        setUploadModal(true);
        const newData = await uploadFileToS3(file);
        setCover([...cover, newData]);
        markDirty();
        handleCloseUpload();
      }
    } catch (error) {
      console.error('Error handling photo:', error);
      alert('Upload Failed: ' + (error.message || JSON.stringify(error)));
      // You might want to set an error state or notify the user
      handleCloseUpload(); // Close the modal even on error
    }
  }

  const handlePhoto = async (e) => {
    try {
      let file = null;

      // If we have an event with files (from a standard input)
      if (e && e.target && e.target.files) {
        if (e.target.files.length === 0) {
          return;
        }
        file = e.target.files[0];
      }
      // Otherwise use either Flutter channel or create a file input
      else {
        // Flutter file channel approach
        if (window.FileChannel) {
          // Set up a callback to receive file data
          file = await new Promise((resolve, reject) => {
            // This part still needs a Promise since we're setting up a callback
            window.fileCallback = (fileData) => {
              console.log('Raw fileData received:', fileData);

              // Handle different possible data formats
              try {
                // Case 1: If fileData is an object with structured properties
                if (typeof fileData === 'object' && fileData !== null) {
                  const { fileName, fileBase64, fileSize, fileType } = fileData;
                  console.log('Structured data detected:', { fileName, fileSize, fileType });

                  if (fileBase64) {
                    // Process base64 data
                    let base64Content = fileBase64;
                    if (fileBase64.includes('base64,')) {
                      base64Content = fileBase64.split('base64,')[1];
                    }

                    // Create blob and file
                    const byteCharacters = atob(base64Content);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: fileType || 'image/jpeg' });
                    const fileObject = new File([blob], fileName || `image_${Date.now()}.jpg`, { type: fileType || 'image/jpeg' });

                    console.log('Created File object from structured data');
                    return resolve(fileObject);
                  }
                }

                // Case 2: If fileData is a string containing base64 data
                if (typeof fileData === 'string') {
                  console.log('String data detected, length:', fileData.length);

                  // If it's base64 format
                  if (fileData.includes('base64')) {
                    const matches = fileData.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

                    if (matches && matches.length === 3) {
                      const mimeType = matches[1];
                      const base64Data = matches[2];

                      // Process base64 data
                      const byteCharacters = atob(base64Data);
                      const byteArrays = [];

                      for (let i = 0; i < byteCharacters.length; i += 1024) {
                        const slice = byteCharacters.slice(i, i + 1024);
                        const byteNumbers = new Uint8Array(slice.length);

                        for (let j = 0; j < slice.length; j++) {
                          byteNumbers[j] = slice.charCodeAt(j);
                        }

                        byteArrays.push(byteNumbers);
                      }

                      const blob = new Blob(byteArrays, { type: mimeType });
                      const fileObject = new File([blob], `image_${Date.now()}.${mimeType.split('/')[1] || 'jpg'}`, { type: mimeType });

                      console.log('Created File object from base64 string');
                      return resolve(fileObject);
                    }
                  }

                  // If it's comma-separated format
                  const parts = fileData.split(',');
                  if (parts.length >= 3) {
                    const [path, name, size] = parts;
                    console.log('Comma-separated data detected:', { path, name, size });
                    // Here we don't have actual file content, just returning the raw data
                    return resolve(fileData);
                  }

                  // If it's just raw base64 without prefix
                  try {
                    // Assume it might be raw base64
                    const byteCharacters = atob(fileData);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
                    const fileObject = new File([blob], `image_${Date.now()}.jpg`, { type: 'image/jpeg' });

                    console.log('Created File object from raw base64');
                    return resolve(fileObject);
                  } catch (e) {
                    console.log('Not valid base64 data');
                  }
                }

                // Fall back to just returning whatever we got
                console.log('Using raw data as fallback');
                return resolve(fileData);
              } catch (error) {
                console.error('Error processing file data:', error);
                return reject(error);
              }
            };

            console.log('Requesting file from Flutter...');
            try {
              window.FileChannel.postMessage('chooseFile');
            } catch (err) {
              console.error('Error calling FileChannel:', err);
              reject(err);
            }
          });
        }
        // Fallback to standard file input approach
        else {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.style.display = 'none';
          document.body.appendChild(input);

          // We need to wrap this in a Promise because file selection is event-based
          file = await new Promise((resolve, reject) => {
            input.onchange = (event) => {
              document.body.removeChild(input);
              if (event.target.files && event.target.files.length > 0) {
                const selectedFile = event.target.files[0];
                console.log('Selected file:', selectedFile);
                resolve(selectedFile);
              } else {
                reject(new Error('No file selected'));
              }
            };

            // Add focus listener to clean up if user cancels
            window.addEventListener('focus', function cleanup() {
              setTimeout(() => {
                if (document.body.contains(input)) {
                  document.body.removeChild(input);
                }
              }, 1000);
              window.removeEventListener('focus', cleanup);
            }, { once: true });

            input.click();
          });
        }
      }

      if (file) {
        setUploadModal(true);
        setIsUploading(true);
        const url = await uploadFileToS3(file);
        setPhotos(url);
        markDirty();
        handleCloseUpload();
      }
    } catch (error) {
      console.error('Error handling photo:', error);
      alert('Upload Failed: ' + (error.message || JSON.stringify(error)));
      handleCloseUpload();
    }
  }

  const handlePosterImage = async (e) => {
    try {
      let file = null;

      // If we have an event with files (from a standard input)
      if (e && e.target && e.target.files) {
        if (e.target.files.length === 0) {
          return;
        }
        file = e.target.files[0];
      }
      // Otherwise use either Flutter channel or create a file input
      else {
        // Flutter file channel approach
        if (window.FileChannel) {
          // Set up a callback to receive file data
          file = await new Promise((resolve, reject) => {
            // This part still needs a Promise since we're setting up a callback
            window.fileCallback = (fileData) => {
              console.log('Raw fileData received:', fileData);

              // Handle different possible data formats
              try {
                // Case 1: If fileData is an object with structured properties
                if (typeof fileData === 'object' && fileData !== null) {
                  const { fileName, fileBase64, fileSize, fileType } = fileData;
                  console.log('Structured data detected:', { fileName, fileSize, fileType });

                  if (fileBase64) {
                    // Process base64 data
                    let base64Content = fileBase64;
                    if (fileBase64.includes('base64,')) {
                      base64Content = fileBase64.split('base64,')[1];
                    }

                    // Create blob and file
                    const byteCharacters = atob(base64Content);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: fileType || 'image/jpeg' });
                    const fileObject = new File([blob], fileName || `image_${Date.now()}.jpg`, { type: fileType || 'image/jpeg' });

                    console.log('Created File object from structured data');
                    return resolve(fileObject);
                  }
                }

                // Case 2: If fileData is a string containing base64 data
                if (typeof fileData === 'string') {
                  console.log('String data detected, length:', fileData.length);

                  // If it's base64 format
                  if (fileData.includes('base64')) {
                    const matches = fileData.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

                    if (matches && matches.length === 3) {
                      const mimeType = matches[1];
                      const base64Data = matches[2];

                      // Process base64 data
                      const byteCharacters = atob(base64Data);
                      const byteArrays = [];

                      for (let i = 0; i < byteCharacters.length; i += 1024) {
                        const slice = byteCharacters.slice(i, i + 1024);
                        const byteNumbers = new Uint8Array(slice.length);

                        for (let j = 0; j < slice.length; j++) {
                          byteNumbers[j] = slice.charCodeAt(j);
                        }

                        byteArrays.push(byteNumbers);
                      }

                      const blob = new Blob(byteArrays, { type: mimeType });
                      const fileObject = new File([blob], `image_${Date.now()}.${mimeType.split('/')[1] || 'jpg'}`, { type: mimeType });

                      console.log('Created File object from base64 string');
                      return resolve(fileObject);
                    }
                  }

                  // If it's comma-separated format
                  const parts = fileData.split(',');
                  if (parts.length >= 3) {
                    const [path, name, size] = parts;
                    console.log('Comma-separated data detected:', { path, name, size });
                    // Here we don't have actual file content, just returning the raw data
                    return resolve(fileData);
                  }

                  // If it's just raw base64 without prefix
                  try {
                    // Assume it might be raw base64
                    const byteCharacters = atob(fileData);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
                    const fileObject = new File([blob], `image_${Date.now()}.jpg`, { type: 'image/jpeg' });

                    console.log('Created File object from raw base64');
                    return resolve(fileObject);
                  } catch (e) {
                    console.log('Not valid base64 data');
                  }
                }

                // Fall back to just returning whatever we got
                console.log('Using raw data as fallback');
                return resolve(fileData);
              } catch (error) {
                console.error('Error processing file data:', error);
                return reject(error);
              }
            };

            console.log('Requesting file from Flutter...');
            try {
              window.FileChannel.postMessage('chooseFile');
            } catch (err) {
              console.error('Error calling FileChannel:', err);
              reject(err);
            }
          });
        }
        // Fallback to standard file input approach
        else {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';

          // We need to wrap this in a Promise because file selection is event-based
          file = await new Promise((resolve, reject) => {
            input.onchange = (event) => {
              if (event.target.files && event.target.files.length > 0) {
                const selectedFile = event.target.files[0];
                console.log('Selected file:', selectedFile);
                resolve(selectedFile);
              } else {
                reject(new Error('No file selected'));
              }
            };

            input.click();
          });
        }
      }

      if (file) {
        setUploadModal(true);
        const url = await uploadFileToS3(file);
        setPoster(url);
        markDirty();
        handleCloseUpload();
      }
    } catch (error) {
      console.error('Error handling photo:', error);
      // You might want to set an error state or notify the user
      handleCloseUpload(); // Close the modal even on error
    }
  }

  const handleCatelogueImage = async (e) => {
    try {
      let file = null;

      // If we have an event with files (from a standard input)
      if (e && e.target && e.target.files) {
        if (e.target.files.length === 0) {
          return;
        }
        file = e.target.files[0];
      }
      // Otherwise use either Flutter channel or create a file input
      else {
        // Flutter file channel approach
        if (window.FileChannel) {
          // Set up a callback to receive file data
          file = await new Promise((resolve, reject) => {
            // This part still needs a Promise since we're setting up a callback
            window.fileCallback = (fileData) => {
              console.log('Raw fileData received:', fileData);

              // Handle different possible data formats
              try {
                // Case 1: If fileData is an object with structured properties
                if (typeof fileData === 'object' && fileData !== null) {
                  const { fileName, fileBase64, fileSize, fileType } = fileData;
                  console.log('Structured data detected:', { fileName, fileSize, fileType });

                  if (fileBase64) {
                    // Process base64 data
                    let base64Content = fileBase64;
                    if (fileBase64.includes('base64,')) {
                      base64Content = fileBase64.split('base64,')[1];
                    }

                    // Create blob and file
                    const byteCharacters = atob(base64Content);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: fileType || 'image/jpeg' });
                    const fileObject = new File([blob], fileName || `image_${Date.now()}.jpg`, { type: fileType || 'image/jpeg' });

                    console.log('Created File object from structured data');
                    return resolve(fileObject);
                  }
                }

                // Case 2: If fileData is a string containing base64 data
                if (typeof fileData === 'string') {
                  console.log('String data detected, length:', fileData.length);

                  // If it's base64 format
                  if (fileData.includes('base64')) {
                    const matches = fileData.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);

                    if (matches && matches.length === 3) {
                      const mimeType = matches[1];
                      const base64Data = matches[2];

                      // Process base64 data
                      const byteCharacters = atob(base64Data);
                      const byteArrays = [];

                      for (let i = 0; i < byteCharacters.length; i += 1024) {
                        const slice = byteCharacters.slice(i, i + 1024);
                        const byteNumbers = new Uint8Array(slice.length);

                        for (let j = 0; j < slice.length; j++) {
                          byteNumbers[j] = slice.charCodeAt(j);
                        }

                        byteArrays.push(byteNumbers);
                      }

                      const blob = new Blob(byteArrays, { type: mimeType });
                      const fileObject = new File([blob], `image_${Date.now()}.${mimeType.split('/')[1] || 'jpg'}`, { type: mimeType });

                      console.log('Created File object from base64 string');
                      return resolve(fileObject);
                    }
                  }

                  // If it's comma-separated format
                  const parts = fileData.split(',');
                  if (parts.length >= 3) {
                    const [path, name, size] = parts;
                    console.log('Comma-separated data detected:', { path, name, size });
                    // Here we don't have actual file content, just returning the raw data
                    return resolve(fileData);
                  }

                  // If it's just raw base64 without prefix
                  try {
                    // Assume it might be raw base64
                    const byteCharacters = atob(fileData);
                    const byteArrays = [];

                    for (let i = 0; i < byteCharacters.length; i += 1024) {
                      const slice = byteCharacters.slice(i, i + 1024);
                      const byteNumbers = new Uint8Array(slice.length);

                      for (let j = 0; j < slice.length; j++) {
                        byteNumbers[j] = slice.charCodeAt(j);
                      }

                      byteArrays.push(byteNumbers);
                    }

                    const blob = new Blob(byteArrays, { type: 'image/jpeg' });
                    const fileObject = new File([blob], `image_${Date.now()}.jpg`, { type: 'image/jpeg' });

                    console.log('Created File object from raw base64');
                    return resolve(fileObject);
                  } catch (e) {
                    console.log('Not valid base64 data');
                  }
                }

                // Fall back to just returning whatever we got
                console.log('Using raw data as fallback');
                return resolve(fileData);
              } catch (error) {
                console.error('Error processing file data:', error);
                return reject(error);
              }
            };

            console.log('Requesting file from Flutter...');
            try {
              window.FileChannel.postMessage('chooseFile');
            } catch (err) {
              console.error('Error calling FileChannel:', err);
              reject(err);
            }
          });
        }
        // Fallback to standard file input approach
        else {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';

          // We need to wrap this in a Promise because file selection is event-based
          file = await new Promise((resolve, reject) => {
            input.onchange = (event) => {
              if (event.target.files && event.target.files.length > 0) {
                const selectedFile = event.target.files[0];
                console.log('Selected file:', selectedFile);
                resolve(selectedFile);
              } else {
                reject(new Error('No file selected'));
              }
            };

            input.click();
          });
        }
      }

      if (file) {
        setUploadModal(true);
        const url = await uploadFileToS3(file);
        setCatelogue([...catelogue, { url, title: "", titleError: "" }]);
        markDirty();
        handleCloseUpload();
      }
    } catch (error) {
      console.error('Error handling photo:', error);
      // You might want to set an error state or notify the user
      handleCloseUpload(); // Close the modal even on error
    }
  }

  const handleBackHome = () => {
    if (isDirty.current) {
      const confirmed = window.confirm(
        "Save ചെയ്യാത്ത മാറ്റങ്ങൾ നഷ്ടപ്പെടും. തുടരണോ?"
      );
      if (!confirmed) return;
    }
    history.push("/");
  };

  const handleShare = async () => {
    const shareData = {
      title: "Add Business",
      text: "Check out this page!",
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied to clipboard");
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  return (
    <div>
      {show == "business" ? (
        <div className="add-business-page-wrapper">
          <div className="add-business-card">
            <div className="add-business-header">
              <CloseIcon
                className="header-close-icon"
                onClick={() => history.push("/")}
              />
              <div className="header-title-box">
                <div className="header-title-icon-circle">
                  <StorefrontIcon className="header-title-icon" />
                </div>
                <h1 className="header-title-text">Add Business</h1>
              </div>
              <ShareIcon
                onClick={handleShare}
                style={{ marginLeft: "auto", cursor: "pointer", color: "#0f172a", fontSize: "24px" }}
              />
            </div>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="add-business-form-body">

                <div className="form-field-group">
                  <label className="form-field-label">
                    Business Name<span className="required-star">*</span>
                  </label>
                  <div className="input-with-icon">
                    <div className="input-icon-box">
                      <ApartmentIcon className="input-icon" />
                    </div>
                    <input
                      placeholder="Business Name"
                      className="form-input"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setNameError("");
                        markDirty();
                      }}
                    />
                  </div>
                  {nameError && nameError.length > 0 && (
                    <div className="error-message">{nameError}</div>
                  )}
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">
                    Phone number<span className="required-star">*</span>
                  </label>
                  <div className="input-with-icon">
                    <div className="input-icon-box">
                      <PhoneIcon className="input-icon" />
                    </div>
                    <input
                      placeholder="Phone number"
                      className="form-input"
                      value={phonenumber}
                      onChange={(e) => {
                        setPhonenumber(e.target.value);
                        setPhoneNumberError("");
                        markDirty();
                      }}
                    />
                  </div>
                  {phoneNumberError && phoneNumberError.length > 0 && (
                    <div className="error-message">{phoneNumberError}</div>
                  )}
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">
                    District<span className="required-star">*</span>
                  </label>
                  <div className="input-with-icon select-wrapper">
                    <div className="input-icon-box">
                      <RoomIcon className="input-icon" />
                    </div>
                    <select
                      className="form-select"
                      value={district}
                      onChange={(e) => { setDistrict(e.target.value); markDirty(); }}
                    >
                      <option value="">Select District</option>
                      {districtList &&
                        districtList.data.results.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                    <KeyboardArrowDownIcon className="select-arrow-icon" />
                  </div>
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">Your City</label>
                  <div className="input-with-icon">
                    <div className="input-icon-box">
                      <MailOutlineIcon className="input-icon" />
                    </div>
                    <input
                      placeholder="Enter Your City"
                      className="form-input"
                      value={postOffice}
                      onChange={(e) => { setPostOffice(e.target.value); markDirty(); }}
                    />
                  </div>
                </div>

                <div className="form-field-group">
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <label className="form-field-label" style={{ marginBottom: 0, whiteSpace: 'nowrap', marginRight: '6px' }}>
                      Location<span className="required-star">*</span>
                    </label>
                    <span style={{
                      fontSize: '11px',
                      letterSpacing: '-0.2px',
                      backgroundColor: '#f1f5f9',
                      padding: '4px 6px',
                      borderRadius: '12px',
                      color: '#0f172a',
                      fontWeight: '600',
                      whiteSpace: 'nowrap'
                    }}>
                      താഴെ ലൊക്കേഷൻ ടൈപ്പ് ചെയ്താൽ<br />ലഭിക്കുന്ന സ്ഥലം ഉറപ്പുവരുത്തണം
                    </span>
                  </div>
                  <div className="input-with-icon">
                    <button
                      type="button"
                      onClick={getLocation}
                      className="input-icon-button"
                      title="Get current location"
                    >
                      <GpsFixedIcon className="input-icon" />
                    </button>
                    <ReactGoogleAutocomplete
                      apiKey={Api_Key}
                      options={{
                        types: [
                          "neighborhood",
                          "locality",
                          "sublocality",
                          "postal_code",
                          "point_of_interest",
                        ],
                        componentRestrictions: { country: "in" },
                        fields: [
                          "address_components",
                          "geometry",
                          "icon",
                          "name",
                          "place_id",
                          "formatted_address",
                        ],
                      }}
                      name="location"
                      defaultValue={placeName ? placeName : ""}
                      onPlaceSelected={(place) => { handleLocation(place); markDirty(); }}
                      style={{
                        outline: "unset",
                        border: "unset",
                        width: "100%",
                        padding: "0 14px",
                        fontSize: "15px",
                        color: "#0f172a",
                        height: "100%",
                      }}
                      placeholder="Enter a location"
                    />
                  </div>
                  {locationError && locationError.length > 0 && (
                    <div className="error-message">{locationError}</div>
                  )}
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">
                    Category<span className="required-star">*</span>
                  </label>
                  <div className="input-with-icon select-wrapper" onClick={() => setCategoryModal(true)}>
                    <div className="input-icon-box ab-cat-icon-box">
                      {categoryImage ? (
                        <img src={categoryImage} alt="" className="ab-cat-icon-img" />
                      ) : (
                        <GridViewIcon className="input-icon" />
                      )}
                    </div>
                    <input
                      placeholder="Select Category"
                      className="form-input clickable-input"
                      value={category}
                      readOnly
                    />
                    <KeyboardArrowDownIcon className="select-arrow-icon" />
                  </div>
                  {categoryError && categoryError.length > 0 && (
                    <div className="error-message">{categoryError}</div>
                  )}
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">Subcategory</label>
                  <div className="input-with-icon select-wrapper" onClick={() => setSubCategoryModal(true)}>
                    <div className="input-icon-box ab-cat-icon-box">
                      {subCategoryImage ? (
                        <img src={subCategoryImage} alt="" className="ab-cat-icon-img" />
                      ) : (
                        <FormatListBulletedIcon className="input-icon" />
                      )}
                    </div>
                    <input
                      placeholder="Select sub category"
                      className="form-input clickable-input"
                      value={subCategory}
                      readOnly
                    />
                    <KeyboardArrowDownIcon className="select-arrow-icon" />
                  </div>
                </div>

                <div className="form-field-group">
                  <label className="form-field-label">Shop Image</label>
                  <div className="shop-image-upload-row">
                    <div className="shop-image-left">
                      <Button
                        variant="outlined"
                        startIcon={<CloudUploadIcon />}
                        className="choose-file-btn"
                        onClick={handlePhoto}
                      >
                        Choose File
                      </Button>
                    </div>
                    <div className="shop-image-right-container">
                      <div className="shop-image-right">
                        {isUploading ? (
                          <div className="shop-placeholder-box">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                              <div className="shop-upload-spinner" />
                              <span style={{ fontSize: "12px", color: "#166B8E", fontWeight: "600" }}>Uploading...</span>
                            </div>
                          </div>
                        ) : !photos ? (
                          <div className="shop-placeholder-box">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="80"
                              height="80"
                              viewBox="0 0 64 64"
                              fill="none"
                            >
                              <rect x="8" y="28" width="48" height="30" rx="3" fill="#d0d0d0" />
                              <path d="M4 28l6-16h44l6 16H4z" fill="#b0b0b0" />
                              <path d="M4 28h56" stroke="#999" strokeWidth="1.5" />
                              <path d="M14 28c0 4.418 3.134 8 7 8s7-3.582 7-8" stroke="#888" strokeWidth="1.5" fill="none" />
                              <path d="M28 28c0 4.418 3.134 8 7 8s7-3.582 7-8" stroke="#888" strokeWidth="1.5" fill="none" />
                              <path d="M42 28c0 4.418 3.134 8 7 8s7-3.582 7-8" stroke="#888" strokeWidth="1.5" fill="none" />
                              <path d="M0 28c0 4.418 3.134 8 7 8s7-3.582 7-8" stroke="#888" strokeWidth="1.5" fill="none" />
                              <rect x="22" y="42" width="20" height="16" rx="2" fill="#b0b0b0" />
                              <rect x="12" y="40" width="12" height="10" rx="2" fill="#c8c8c8" />
                              <rect x="40" y="40" width="12" height="10" rx="2" fill="#c8c8c8" />
                            </svg>
                          </div>
                        ) : (
                          <div className="shop-image-preview">
                            <img src={photos} alt="Shop Preview" className="shop-actual-preview-img" />
                            <img
                              src={deleteicon}
                              alt="Delete"
                              className="delete-image-icon"
                              onClick={() => {
                                setOpenModal(true);
                                setSelectedImage("photos");
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <p className="malayalam-helper">
                    നിങ്ങളുടെ സ്ഥാപനത്തെയോ സേവനത്തെയോ വ്യക്തമായി തിരിച്ചറിയാൻ സഹായിക്കുന്ന, കുറഞ്ഞ ഫയൽ സൈസിലുമുള്ള ഒരു ചിത്രം അല്ലെങ്കിൽ വിസിറ്റിംഗ് കാർഡ് അപ്ലോഡ് ചെയ്യുക. സ്ഥാപനത്തിന്റെ ലോഗോ, കടയുടെ മുൻവശം, സൈൻബോർഡ്, അല്ലെങ്കിൽ വിസിറ്റിംഗ് കാർഡ് എന്നിവ ഉപയോഗിക്കാം. വ്യക്തമായി തിരിച്ചറിയാൻ കഴിയുന്ന ചിത്രം തിരഞ്ഞെടുക്കുക. അനുവദനീയമായ ഫോർമാറ്റുകൾ: JPG, PNG (പരമാവധി .4 MB).
                  </p>
                  <div className="ab-btn-row">
                    <Button
                      variant="contained"
                      startIcon={<FaSave />}
                      className="form-save-btn"
                      onClick={handleSave}
                      disabled={isUploading}
                    >
                      Save
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<HomeIcon />}
                      className="form-back-home-btn"
                      onClick={handleBackHome}
                      type="button"
                    >
                      Back Home
                    </Button>
                  </div>
                  <div className="approval-notice-panel">
                    രജിസ്ട്രേഷൻ പൂർത്തിയായതിനു ശേഷം 24 മണിക്കൂറിനുള്ളിൽ അപ്രൂവൽ ലഭിക്കുന്നതാണ്.
                  </div>

                  {/* ── Quick-nav buttons ── */}
                  <div className="ab-quicknav-row">
                    <Button
                      variant="contained"
                      startIcon={<AccountCircleIcon />}
                      className="ab-quicknav-btn ab-quicknav-profile"
                      onClick={() => history.push("/my-profile")}
                      type="button"
                    >
                      My Profile
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<CardMembershipIcon />}
                      className="ab-quicknav-btn ab-quicknav-subscription"
                      onClick={() => history.push("/subscription-plan")}
                      type="button"
                    >
                      Subscription Plans
                    </Button>
                  </div>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    id="file"
                    accept=".jpg,.jpeg,.png"
                    ref={photoref}
                    onChange={handlePhoto}
                  />
                </div>

              </div>
            </form>
          </div>

          <div className="registration-help-card">
            <div className="help-left">
              <div className="help-icon-circle">
                <HeadsetMicIcon className="help-icon" />
              </div>
              <span className="help-text">If you need help for registration</span>
              <div className="help-divider-line"></div>
            </div>
            <div className="help-actions">
              <a
                href="https://wa.me/917293838383?text=Hello"
                target="_blank"
                rel="noreferrer"
                className="help-btn whatsapp-btn"
              >
                <WhatsAppIcon className="btn-icon" /> WHATSAPP
              </a>
              <a
                href="tel:+917293838383"
                className="help-btn call-btn"
              >
                <PhoneIcon className="btn-icon" /> CALL
              </a>
            </div>
          </div>
        </div>
      ) : null}
      {show == "more details" ? (
        <Fragment>
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
              color: "black",
              display: "flex",
              width: "100%",
              alignItems: "center",
              gap: "1rem",
              flexDirection: "row",
              padding: "1rem",
              position: "fixed",
              top: 0,
            }}
          >
            <ArrowBackIcon
              onClick={() => setShow("business")}
              style={{
                color: "black",
              }}
            />

            <p style={{ color: "black" }}>Add More Details </p>
          </div>

          <div
            className="completeRegistration-form-body"
            style={{ marginTop: "4rem" }}
          >
            <p style={{ fontWeight: "bold" }}>Pin Code</p>
            <input
              placeholder="Enter Pincode"
              className="reg-inp"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>About your Business</p>
            <textarea
              placeholder="About"
              className="reg-textarea"
              value={about}
              onChange={(e) => setAbout(e.target.value)}
              rows="3"
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "2rem",
            }}
          >
            <button
              className="next-btn"
              onClick={() => {
                if (
                  trailPlan &&
                  trailPlan?.data?.results?.[0]?.subscription_features?.service
                ) {
                  setShow("service");
                } else {
                  setShow("socialMedia");
                }
              }}
            >
              <BsArrowRight />
            </button>
          </div>
        </Fragment>
      ) : null}
      {show == "service" ? (
        <Fragment>
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
              color: "black",
              display: "flex",
              width: "100%",
              alignItems: "center",
              gap: "1rem",
              flexDirection: "row",
              padding: "1rem",
              position: "fixed",
              top: 0,
            }}
          >
            <ArrowBackIcon
              onClick={() => setShow("more details")}
              style={{
                color: "black",
              }}
            />
            <p style={{ color: "black" }}>Add Service </p>
          </div>
          <div
            className="completeRegistration-form-body"
            style={{ marginTop: "4rem" }}
          >
            <p style={{ fontWeight: "bold" }}>Services </p>
            {add.map((item, i) => {
              if (i < 10) {
                return (
                  <input
                    placeholder="Enter "
                    className="reg-inp"
                    value={item.name}
                    onChange={(e) => handleAdd(e, i)}
                    maxLength={20}
                  />
                );
              }
            })}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: theme.palette.secondary.main,
                borderRadius: "12px",
                height: "3rem",
                width: "169px",
              }}
              onClick={() => setAdd([...add, { name: "" }])}
            >
              Add more
            </Button>
          </div>
          <div
            onClick={() => setShow("socialMedia")}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "2rem",
            }}
          >
            <div className="next-btn">
              <BsArrowRight />
            </div>
          </div>
        </Fragment>
      ) : null}
      {show == "socialMedia" ? (
        <Fragment>
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
              color: "black",
              display: "flex",
              width: "100%",
              alignItems: "center",
              gap: "1rem",
              flexDirection: "row",
              padding: "1rem",
              position: "fixed",
              top: 0,
            }}
          >
            <ArrowBackIcon
              onClick={() => {
                if (
                  trailPlan &&
                  trailPlan?.data?.results?.[0]?.subscription_features?.service
                ) {
                  setShow("service");
                } else {
                  setShow("more details");
                }
              }}
              style={{
                color: "black",
              }}
            />
            <p style={{ color: "black" }}>Add Social Media </p>
          </div>

          <div
            className="completeRegistration-form-body"
            style={{ marginTop: "4rem" }}
          >
            <p style={{ fontWeight: "bold" }}>Google Location Link</p>
            <input
              placeholder="Enter"
              className="reg-inp"
              value={googleLocation}
              onChange={(e) => setGoogleLocation(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>Whatsapp Phone number </p>
            <input
              placeholder="Enter"
              className="reg-inp"
              value={Whatsapp}
              onChange={(e) => setWhatsApp(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>Facebook </p>
            <input
              placeholder="Enter the profile link "
              className="reg-inp"
              value={facebook}
              onChange={(e) => setFacebook(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>Instagram </p>
            <input
              placeholder="Enter the profile link "
              className="reg-inp"
              value={instagram}
              onChange={(e) => setInstagram(e.target.value)}
            />
            <p style={{ fontWeight: "bold" }}>Google Review </p>
            <input
              placeholder="Enter the google review link "
              className="reg-inp"
              value={google_review_link}
              onChange={(e) => setGoogle_review_link(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>Youtube </p>
            <input
              placeholder="Enter the profile link"
              className="reg-inp"
              value={youtube}
              onChange={(e) => setYoutube(e.target.value)}
            />

            <p style={{ fontWeight: "bold" }}>Website </p>
            <input
              placeholder="Enter the Website link"
              className="reg-inp"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>

          <div
            onClick={() => setShow("coverPhoto")}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "2rem",
            }}
          >
            <div className="next-btn">
              <BsArrowRight />
            </div>
          </div>
        </Fragment>
      ) : null}

      {show == "coverPhoto" ? (
        <Fragment>
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
              color: "black",
              display: "flex",
              width: "100%",
              alignItems: "center",
              gap: "1rem",
              flexDirection: "row",
              padding: "1rem",
              position: "fixed",
              top: 0,
              zIndex: "100",
            }}
          >
            <ArrowBackIcon
              onClick={() => setShow("socialMedia")}
              style={{
                color: "black",
              }}
            />
            <p style={{ color: "black" }}>Add Cover Photo</p>
          </div>

          <div
            style={{
              marginTop: "50px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {poster ? (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  top: "20px",
                }}
              >
                <img
                  src={poster}
                  width={"92%"}
                  height={"224px"}
                  style={{
                    borderRadius: "20px",
                    border: "4px solid rgba(22, 107, 142, 1)",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                  onClick={handlePosterImage}
                />
                <img
                  src={deleteicon}
                  style={{
                    position: "absolute",
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                    right: "30px",
                    top: "19px",
                  }}
                  onClick={() => {
                    setOpenModal(true);
                    setSelectedImage("poster");
                  }}
                />
              </div>
            ) : (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
                ref={premiumRef}
                onClick={handlePosterImage}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    color: "#677eff",
                    width: "92%",
                    height: "3rem",
                    border: "none",
                    backgroundColor: "#fff",
                    border: "solid 3px #166B8E",
                    borderRadius: "35px",
                    padding: "8rem",
                  }}
                >
                  <span
                    style={{
                      width: "100%",
                      borderRadius: "30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img src="/images/img-icon.png" />
                    <p style={{ color: "#2182B1" }}>
                      Add Banner Image
                    </p>
                  </span>
                </label>
              </div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {cover.map((item, i) => (
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  top: "20px",
                }}
              >
                {" "}
                <img
                  src={item}
                  width={"92%"}
                  height={"224px"}
                  style={{
                    borderRadius: "20px",
                    border: "4px solid rgba(22, 107, 142, 1)",
                    marginBottom: "10px",
                  }}
                />
                <img
                  src={deleteicon}
                  style={{
                    position: "absolute",
                    width: "24px",
                    height: "24px",
                    cursor: "pointer",
                    right: "30px",
                    top: "19px",
                  }}
                  onClick={() => {
                    setOpenModal(true);
                    setId(i);
                    setSelectedImage("cover");
                  }}
                />
              </div>
            ))}
          </div>
          {trailPlan?.data?.results[0]?.subscription_features?.cover_images ==
            cover.length ? (
            ""
          ) : (
            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
              ref={ref}
              onClick={handleCoverImage}
            >
              {/* <input
                style={{
                  display: "none",
                }}
                type="file"
                id="file"
                accept=".jpg,.jpeg,.png"
                ref={ref}
              /> */}
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#677eff",
                  width: "92%",
                  height: "3rem",
                  border: "none",
                  color: "info",
                  backgroundColor: "#fff",
                  border: "solid 3px #166B8E",
                  borderRadius: "35px",
                  padding: "8rem",
                }}
                htmlFor="file"
              >
                <i className=" fs-3 fa-solid fa-image"></i>
                <span
                  style={{
                    width: "100%",
                    borderRadius: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <img src="/images/img-icon.png" />
                  <p style={{ color: "#2182B1" }}>
                    Add Cover Image for your business
                  </p>
                </span>
              </label>
            </div>
          )}

          {trailPlan?.data?.results[0]?.subscription_features?.cover_images ==
            cover.length ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "2rem 0",
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  borderRadius: "12px",
                  height: "3rem",
                }}
                onClick={() => ref.current.click()}
              >
                Add more images
              </Button>
            </div>
          )}

          <div
            onClick={() => setShow("catelogue")}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "2rem",
              position: "fixed",
              bottom: 0,
              width: "82%",
            }}
          >
            <div className="next-btn">
              <BsArrowRight />
            </div>
          </div>
        </Fragment>
      ) : null}

      {show === "catelogue" ? (
        <Fragment>
          <div
            style={{
              backgroundColor: "#fff",
              boxShadow: "-2px 0px 5px rgba(22, 107, 142, 0.25)",
              color: "black",
              display: "flex",
              width: "100%",
              alignItems: "center",
              gap: "1rem",
              flexDirection: "row",
              padding: "1rem",
              position: "fixed",
              top: 0,
              zIndex: "100",
            }}
          >
            <ArrowBackIcon
              onClick={() => setShow("coverPhoto")}
              style={{
                color: "black",
              }}
            />
            <p style={{ color: "black" }}>Add Catalogue Photos</p>
          </div>

          <div
            style={{
              marginTop: "50px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {catelogue.map((item, i) => (
              <>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    top: "20px",
                  }}
                >
                  {" "}
                  <img
                    src={item?.url}
                    width={"92%"}
                    height={"224px"}
                    style={{
                      borderRadius: "20px",
                      border: "4px solid rgba(22, 107, 142, 1)",
                      marginBottom: "10px",
                    }}
                  />
                  <img
                    src={deleteicon}
                    style={{
                      position: "absolute",
                      width: "24px",
                      height: "24px",
                      cursor: "pointer",
                      right: "30px",
                      top: "19px",
                    }}
                    onClick={() => {
                      setOpenModal(true);
                      setId(i);
                      setSelectedImage("catelogue");
                    }}
                  />
                </div>
                <div
                  style={{ width: "100%", marginTop: "6px", padding: "10px 20px" }}
                >
                  <p style={{ fontWeight: "bold", marginBottom: "6px" }}>
                    Title<span style={{ color: "red" }}>*</span>
                  </p>
                  <input
                    placeholder="Business Name"
                    className="reg-inp"
                    value={item.title}
                    maxLength={14}
                    onChange={(e) => {
                      let data = [...catelogue];
                      data[i].title = e.target.value;
                      data[i].titleError = "";
                      setCatelogue([...data]);

                    }}
                  />
                  {item.titleError && item.titleError.length > 0 && (
                    <div className="error-message">{item.titleError}</div>
                  )}
                </div>
              </>
            ))}
          </div>
          {catelogue.length ==
            trailPlan?.data?.results[0]?.subscription_features
              ?.catalogue_images ? null : (
            <div
              style={{
                marginTop: "2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
              ref={catelogueRef}
              onClick={handleCatelogueImage}
            >
              {/* <input
                style={{
                  display: "none",
                }}
                type="file"
                id="file"
                accept=".jpg,.jpeg,.png"
                
              /> */}
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  color: "#677eff",
                  width: "92%",
                  height: "3rem",
                  border: "none",
                  color: "info",
                  backgroundColor: "#fff",
                  border: "solid 3px #166B8E",
                  borderRadius: "35px",
                  padding: "8rem",
                }}
                htmlFor="file"
              >
                <i className=" fs-3 fa-solid fa-image"></i>
                <span
                  style={{
                    width: "100%",
                    borderRadius: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <img src="/images/img-icon.png" />
                  <p style={{ color: "#2182B1" }}>
                    Add Catalogue Image for your business
                  </p>
                </span>
              </label>
            </div>
          )}

          {catelogue.length ==
            trailPlan?.data?.results[0]?.subscription_features
              ?.catalogue_images ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "2rem 0",
              }}
            >
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  borderRadius: "12px",
                  height: "3rem",
                }}
              >
                Add{" "}
                {trailPlan?.data?.results[0]?.subscription_features
                  ?.catalogue_images - catelogue.length}{" "}
                more images
              </Button>
            </div>
          )}

          {/* ── SAVE & CONTINUE — prominent labeled button at bottom of catalogue section ── */}
          <div style={{ padding: "24px 16px 100px", display: "flex", flexDirection: "column", gap: 12, alignItems: "stretch" }}>
            <Button
              variant="contained"
              size="large"
              disabled={isAddingBusiness || isEditingBusiness}
              onClick={handleBusiness}
              startIcon={isAddingBusiness || isEditingBusiness ? null : <FaSave />}
              style={{
                backgroundColor: isAddingBusiness || isEditingBusiness ? "#90a4ae" : "#0f766e",
                color: "#ffffff",
                borderRadius: "12px",
                height: "54px",
                fontSize: "1rem",
                fontWeight: 700,
                letterSpacing: "0.5px",
                boxShadow: "0 4px 14px rgba(15,118,110,0.3)",
                transition: "all 0.2s ease",
              }}
            >
              {isAddingBusiness || isEditingBusiness ? "Saving…" : "SAVE & CONTINUE"}
            </Button>
          </div>

          <div
            onClick={!isAddingBusiness && !isEditingBusiness ? handleBusiness : undefined}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              margin: "2rem",
              position: "fixed",
              bottom: 0,
              width: "82%",
            }}
          >
            <div className="next-btn">
              <FaSave style={{ fontSize: "1.5rem" }} />
            </div>
          </div>
        </Fragment>
      ) : null}

      {openModal ? (
        <ImageRemovalModal open={openModal} handleClose={handleClose} />
      ) : null}
      {openError ? (
        <ErrorModal
          open={openError}
          handleClose={handleError}
          message={errorMessage}
        />
      ) : null}

      {openSuccess ? (
        <SuccessModal
          open={openSuccess}
          handleClose={handleSuccess}
          title="OK"
          message="Saved successfully"
        />
      ) : null}
      {openCropModal ? (
        <CropModal
          open={openCropModal}
          handleClose={handleCloseCrop}
          setCroppingImage={setCroppingImage}
          croppingImage={croppingImage}
        />
      ) : null}
      {uploadModal ? (
        <UploadModal open={uploadModal} handleClose={handleCloseUpload} />
      ) : null}
      {categoryModal ? (
        <CategoryModal
          open={categoryModal}
          setOpen={setCategoryModal}
          handleClose={handleCategoryModal}
          categoryId={categoryId}
        />
      ) : null}
      {subCategoryModal ? (
        <SubCategoryModal
          open={subCategoryModal}
          setOpen={setSubCategoryModal}
          handleClose={handleSubCategoryModal}
          categoryId={categoryId}
          subCategoryId={subCategoryId}
        />
      ) : null}
    </div>
  );
};

export default AddBusiness;
